module.exports = __webpack_public_path__ + "static/media/cat1.5beef382.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat1.jpeg
// module id = 33
// module chunks = 0